import { render, staticRenderFns } from "./EcoendoscopiaViewComponent.vue?vue&type=template&id=1d01a001"
import script from "./EcoendoscopiaViewComponent.vue?vue&type=script&lang=js"
export * from "./EcoendoscopiaViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports